module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Lista notowań")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('date-picker', {
    on: {
      "input": _vm.update
    },
    model: {
      value: (_vm.localId),
      callback: function($$v) {
        _vm.localId = $$v
      },
      expression: "localId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary spaced",
    attrs: {
      "to": {
        name: 'ProductAdd'
      }
    }
  }, [_vm._v("Dodaj produkt")]), _vm._v(" "), (_vm.showChangesAlert) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('strong', [_c('info-icon'), _vm._v("\n          Informacja\n          "), _c('br')], 1), _vm._v("\n        Wprowadzono zmiany w notowaniach\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('question-button', {
    staticClass: "btn btn-info pull-right",
    attrs: {
      "question": "Czy na pewno opublikować zmiany cen?"
    },
    on: {
      "click": _vm.publish
    }
  }, [_vm._v("Opublikuj\n        ")])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spaced"
  }, [_c('question-button', {
    staticClass: "pull-left btn btn-default",
    attrs: {
      "question": _vm.notifyQuestion
    },
    on: {
      "click": _vm.sendNotifications
    }
  }, [_vm._v("\n      Wyślij powiadomienia\n    ")]), _vm._v(" "), (_vm.viewMode) ? _c('button', {
    staticClass: "pull-right btn btn-default",
    on: {
      "click": _vm.setEditMode
    }
  }, [_vm._v("\n      Aktualizuj wszystkie\n    ")]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('button', {
    staticClass: "pull-right btn btn-default",
    on: {
      "click": _vm.unsetEditMode
    }
  }, [_vm._v("\n      Anuluj\n    ")]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('button', {
    staticClass: "pull-right btn btn-info",
    on: {
      "click": _vm.usePreviousCard
    }
  }, [_vm._v("\n      Użyj poprzednich notowań\n    ")]) : _vm._e(), _vm._v(" "), (_vm.editMode && _vm.showSaveEditModeButton) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": _vm.saveEditModePrices
    }
  }, [_c('save-icon'), _vm._v("\n      Zapisz\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.editMode && _vm.showSaveEditModeButton) ? _c('button', {
    staticClass: "pull-right btn btn-default",
    on: {
      "click": _vm.setViewMode
    }
  }, [_vm._v("\n      Anuluj\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.card.records), function(record) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(record.product.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.product.variety))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.product.origin))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.product.enabled))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.product.unit))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-left"
    }, [_vm._l((record.publicPrices), function(price) {
      return [_vm._v("\n          " + _vm._s(_vm._f("currency")(price.price)) + " "), _c('br')]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "pull-right",
      staticStyle: {
        "max-width": "100px"
      }
    }, [_vm._l((record.draftPrices), function(price) {
      return _c('span', {
        staticClass: "draft-price"
      }, [_vm._v("\n            " + _vm._s(_vm._f("currency")(price.price)) + " "), _c('br')])
    }), _vm._v(" "), _vm._l((record.editModePrices), function(price, index) {
      return (_vm.editMode) ? _c('div', {
        staticClass: "input-group input-group-sm"
      }, [_c('currency-input', {
        staticClass: "input-sm",
        model: {
          value: (price.price),
          callback: function($$v) {
            price.price = $$v
          },
          expression: "price.price"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "input-group-btn"
      }, [_c('button', {
        staticClass: "btn btn-danger",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.removeEditModePrice(record, index)
          }
        }
      }, [_c('minus-icon')], 1)])], 1) : _vm._e()
    }), _vm._v(" "), (_vm.editMode) ? _c('button', {
      staticClass: "btn btn-info btn-sm",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "button",
        "title": "Dodaj nową cenę"
      },
      on: {
        "click": function($event) {
          _vm.addEditModePriceTo(record)
        }
      }
    }, [_c('plus-icon'), _vm._v("\n            dodaj cenę\n          ")], 1) : _vm._e()], 2)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-left"
    }, [_vm._v("\n          " + _vm._s(_vm._f("currency")(record.publicAvgPrice)) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [(record.draftPrices.length > 0) ? _c('span', {
      staticClass: "draft-price"
    }, [_vm._v("\n            " + _vm._s(_vm._f("currency")(record.draftAvgPrice)) + "\n          ")]) : _vm._e()])]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'RecordEdit',
          params: {
            id: record.id
          }
        }
      }
    }, [_vm._v("edytuj")])], 1)])
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Produkt")]), _vm._v(" "), _c('th', [_vm._v("Odmiana")]), _vm._v(" "), _c('th', [_vm._v("Pochodzenie")]), _vm._v(" "), _c('th', [_vm._v("Dostępność")]), _vm._v(" "), _c('th', [_vm._v("Jednostka")]), _vm._v(" "), _c('th', [_vm._v("Ceny")]), _vm._v(" "), _c('th', [_vm._v("Cena średnia")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-325202a3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Records.vue
// module id = 434
// module chunks = 1